import { render, staticRenderFns } from "./aRmsDayGeneralKpiRow.vue?vue&type=template&id=3d878c18&scoped=true"
import script from "./aRmsDayGeneralKpiRow.vue?vue&type=script&lang=js"
export * from "./aRmsDayGeneralKpiRow.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayGeneralKpiRow.vue?vue&type=style&index=0&id=3d878c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d878c18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
